import { ProjectSettings } from "../api_interfaces/project/ProjectSettings";

export const PROJECT_SETTINGS_DEFAULT: ProjectSettings = {
    responsibleRequired: true,
    changeColumnStatus: false
};
export const MAX_DESCRIPTION_LENGTH = 250;
export const MAX_NAME_LENGTH = 30;
export const ABBREVIATION_MIN_LENGTH = 3;
export const ABBREVIATION_MAX_LENGTH = 5;